import {Component, ChangeDetectionStrategy} from '@angular/core';
import {ServiceWorkerUpdateService} from './services/service-worker-update.service';
import {RouterOutlet} from '@angular/router';
import {ConnectionStatusComponent} from '@shared/connection-handling/connection-status/connection-status.component';
import {CheckerUpdateService} from '@services/checker-update.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterOutlet, ConnectionStatusComponent]
})
export class AppComponent {
  constructor(
    private _serviceWorkerUpdate: ServiceWorkerUpdateService,
    private _checkerUpdate: CheckerUpdateService
  ) { }
}
